import { useState, useEffect, createContext, useContext, useCallback, useMemo, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import KPIDashboardPage from "./pages/KPIDashboardPage";
import MyDashboardPage from "./pages/MyDashboardPage";
import QAiaPage from "./pages/QAiaPage";
import ComparePage from "./pages/ComparePage";
import ConverterPage from "./pages/ConverterPage";
import PublicidadesPage from "./pages/PublicidadesPage";
import ComparisonResultPage from "./pages/ComparisonResultPage";
import ReportsPage from "./pages/ReportsPage";
import TemplatesPage from "./pages/TemplatesPage";
import UsuariosPage from "./pages/UsuariosPage";
import GestionHumanaPage from "./pages/GestionHumanaPage";
import PermisosPage from "./pages/PermisosPage";
import AutomatizacionesPage from "./pages/AutomatizacionesPage";
import BaseDatosFlujos from "./pages/BaseDatosFlujos";
import DepartamentosPage from "./pages/DepartamentosPage";
import CamposPersonalizadosPage from "./pages/CamposPersonalizadosPage";
import AseguradorasPage from "./pages/AseguradorasPage";
import ComparativosBeneficiosPage from "./pages/ComparativosBeneficiosPage";
import PlantillasBeneficiosPage from "./pages/PlantillasBeneficiosPage";
// Gestión Humana sub-pages
import EmpleadosPage from "./pages/EmpleadosPage";
import VacacionesPage from "./pages/VacacionesPage";
import ReclutamientoPage from "./pages/ReclutamientoPage";
import ParametrosGHPage from "./pages/ParametrosGHPage";
import PlantillasGHPage from "./pages/PlantillasGHPage";
import SolicitudesGHPage from "./pages/SolicitudesGHPage";
import DashboardRRHHPage from "./pages/DashboardRRHHPage";
import NominaPage from "./pages/NominaPage";
import ProcesosInternosPage from "./pages/ProcesosInternosPage";
import PortalProcedimientosPage from "./pages/PortalProcedimientosPage";
// Mensajería pages
import SolicitudesMensajeriaPage from "./pages/SolicitudesMensajeriaPage";
import MensajerosPage from "./pages/MensajerosPage";
import TiposDocumentoPage from "./pages/TiposDocumentoPage";
import HistorialMensajeriaPage from "./pages/HistorialMensajeriaPage";
import ChatMensajeriaPage from "./pages/ChatMensajeriaPage";
import AlertasMensajeriaPage from "./pages/AlertasMensajeriaPage";
import ClientesMensajeriaPage from "./pages/ClientesMensajeriaPage";
import CorrespondenciaInternaPage from "./pages/mensajeria/CorrespondenciaInternaPage";
// Mesa de Ayuda pages
import TicketsPage from "./pages/TicketsPage";
import MisTicketsPage from "./pages/MisTicketsPage";
import ManualPage from "./pages/ManualPage";
import CategoriasTicketPage from "./pages/CategoriasTicketPage";
import PrioridadesTicketPage from "./pages/PrioridadesTicketPage";
import PlantillasTicketsPage from "./pages/PlantillasTicketsPage";
import HallazgosAuditoriaPage from "./pages/HallazgosAuditoriaPage";
import PlantillasMensajeriaPage from "./pages/PlantillasMensajeriaPage";
// Planes page
import PlanesPage from "./pages/PlanesPage";
// Coberturas de Pólizas
import CoberturasPolizasPage from "./pages/CoberturasPolizasPage";
// Reportes del Sistema
import ReportesSistemaPage from "./pages/ReportesSistemaPage";
import ReportesPersonalizadosPage from "./pages/ReportesPersonalizadosPage";
// Admin Menus
import AdminMenusPage from "./pages/AdminMenusPage";
// Mobile App
import AppEntregasPage from "./pages/AppEntregasPage";
import AppMovilConfigPage from "./pages/AppMovilConfigPage";
import MobileLayout from "./components/MobileLayout";
import PushPermissionBanner from "./components/PushPermissionBanner";
// Notificaciones Config
import NotificacionesConfigPage from "./pages/NotificacionesConfigPage";
import NotificacionesPushPage from "./pages/NotificacionesPushPage";
// Aprendizaje IA
import AprendizajePage from "./pages/AprendizajePage";
// WhatsApp Module
import WhatsAppConfigPage from "./pages/WhatsAppConfigPage";
import WhatsAppBandejaPage from "./pages/WhatsAppBandejaPage";
import WhatsAppAsignacionesPage from "./pages/WhatsAppAsignacionesPage";
import WhatsAppRespuestasPage from "./pages/WhatsAppRespuestasPage";
import WhatsAppPlantillasPage from "./pages/WhatsAppPlantillasPage";
import WhatsAppChatbotPage from "./pages/WhatsAppChatbotPage";
import WhatsAppContactosPage from "./pages/WhatsAppContactosPage";
import WhatsAppEstadisticasPage from "./pages/WhatsAppEstadisticasPage";
import WhatsAppWorkflowPage from "./pages/WhatsAppWorkflowPage";
// Audit Log
import AuditLogPage from "./pages/AuditLogPage";
import AuditoriaInventarioPage from "./pages/AuditoriaInventarioPage";
// Inventario Module
import InventarioDashboardPage from "./pages/InventarioDashboardPage";
import InventarioArticulosPage from "./pages/InventarioArticulosPage";
// Requisiciones Module
import RequisicionesPage from "./pages/RequisicionesPage";
import NuevaRequisicionPage from "./pages/NuevaRequisicionPage";
import AprobarRequisicionPage from "./pages/AprobarRequisicionPage";
import HistorialRequisicionesPage from "./pages/HistorialRequisicionesPage";
import ArticulosPage from "./pages/ArticulosPage";
import EntradasInventarioPage from "./pages/EntradasInventarioPage";
import SalidasInventarioPage from "./pages/SalidasInventarioPage";
import MovimientosInventarioPage from "./pages/MovimientosInventarioPage";
import CategoriasInventarioPage from "./pages/CategoriasInventarioPage";
// Mobiliario Module
import MobiliarioDashboardPage from "./pages/MobiliarioDashboardPage";
import MobiliarioActivosPage from "./pages/MobiliarioActivosPage";
import MobiliarioAsignacionesPage from "./pages/MobiliarioAsignacionesPage";
import MobiliarioMantenimientoPage from "./pages/MobiliarioMantenimientoPage";
import MobiliarioBajasPage from "./pages/MobiliarioBajasPage";
import MobiliarioCategoriasPage from "./pages/MobiliarioCategoriasPage";
import MobiliarioUbicacionesPage from "./pages/MobiliarioUbicacionesPage";
// Finanzas Module
import MedicamentosPage from "./pages/MedicamentosPage";
import CajaChicaPage from "./pages/CajaChicaPage";
import GrabacionesPage from "./pages/GrabacionesPage";
import LionBridgeCuadreCajaPage from "./pages/LionBridgeCuadreCajaPage";
import LionbridgeEmisionesPage from "./pages/LionbridgeEmisionesPage";
import CajaChicaConfigPage from "./pages/CajaChicaConfigPage";
// Cuentas por Pagar Module
import CuentasPagarPage from "./pages/CuentasPagarPage";
import ProveedoresPage from "./pages/ProveedoresPage";
import AlertasPagosPage from "./pages/AlertasPagosPage";
import HistorialCuentasPagarPage from "./pages/HistorialCuentasPagarPage";
// Control Visitantes Module
import ControlVisitantesPage from "./pages/ControlVisitantesPage";
import HistorialVisitasPage from "./pages/HistorialVisitasPage";
import TiposVisitaPage from "./pages/TiposVisitaPage";
import ReportesVisitasPage from "./pages/ReportesVisitasPage";
import AlertasVisitantesPage from "./pages/AlertasVisitantesPage";
// Gestión Humana - New Modules
import PermisosGHPage from "./pages/PermisosGHPage";
import CumpleanosPage from "./pages/CumpleanosPage";
import TardanzasPage from "./pages/TardanzasPage";
import SolicitudesUnificadasPage from "./pages/SolicitudesUnificadasPage";
import MovimientosGHPage from "./pages/MovimientosGHPage";
import AlertasSolicitudesPage from "./pages/AlertasSolicitudesPage";
import CambiarContrasenaPage from "./pages/CambiarContrasenaPage";
import ReportarErrorPage from "./pages/ReportarErrorPage";
import AdminReportesErroresPage from "./pages/AdminReportesErroresPage";
import PCCPage from "./pages/pcc/PCCPage";
import PCCPortalPage from "./pages/pcc/PCCPortalPage";
import PipelinesPage from "./pages/pipelines/PipelinesPage";
import PanelesPage from "./pages/pipelines/PanelesPage";
import InformesPage from "./pages/pipelines/InformesPage";
import InformesDocumentosPage from "./pages/pipelines/InformesDocumentosPage";
import PlantillasPipelinePage from "./pages/pipelines/PlantillasPage";
import WorkflowPage from "./pages/pipelines/WorkflowPage";
import TareasPipelinePage from "./pages/pipelines/TareasPage";
// === ALNAP START ===
import AlnapDemoPage from "./pages/AlnapDemoPage";
import AlnapPublicPage from "./pages/AlnapPublicPage";
// === ALNAP END ===
import BugResolvedAnnouncements from "./components/BugResolvedAnnouncements";
import TicketUrgenteAnnouncements from "./components/TicketUrgenteAnnouncements";
import PersonalizacionPage from "./pages/PersonalizacionPage";
import LimpiezaBaseDatosPage from "./pages/LimpiezaBaseDatosPage";
import ReglasAlertasPage from "./pages/ReglasAlertasPage";
import CamposObligatoriosPage from "./pages/CamposObligatoriosPage";
import AlertasExecutorPage from "./pages/AlertasExecutorPage";
import BackupPage from "./pages/BackupPage";
import PlantillasCorreosPage from "./pages/PlantillasCorreosPage";
import FirmaDigitalPage from "./pages/FirmaDigitalPage";
import ReglasEmailPage from "./pages/ReglasEmailPage";
import EmailLogsPage from "./pages/EmailLogsPage";
import OperacionesPorUsuarioPage from "./pages/OperacionesPorUsuarioPage";
import ControlLlamadasPage from "./pages/ControlLlamadasPage";
import ConfigLlamadasPage from "./pages/ConfigLlamadasPage";
import ControlRenovacionesPage from "./pages/ControlRenovacionesPage";
import BandejaEntradaPage from "./pages/BandejaEntradaPage";
import PresentacionesIAPage from "./pages/PresentacionesIAPage";
import SistemaPonchePage from "./pages/SistemaPonchePage";
import CamarasPage from "./pages/CamarasPage";
import TarjetasCreditoPage from "./pages/cobros/TarjetasCreditoPage";
import ChequesQBPage from "./pages/cobros/ChequesQBPage";
import DGIIReportesPage from "./pages/DGIIReportesPage";
import RegistroTarjetaPublicaPage from "./pages/RegistroTarjetaPublicaPage";
import VerTarjetaAseguradoraPage from "./pages/VerTarjetaAseguradoraPage";
import SalidaEquiposPage from "./pages/SalidaEquiposPage";
import PlantillasAseguradorasPage from "./pages/riesgos-generales/PlantillasAseguradorasPage";
// Encuestas NPS Module
import EncuestasConfigPage from "./pages/EncuestasConfigPage";
import EncuestasCampanasPage from "./pages/EncuestasCampanasPage";
import EncuestasResultadosPage from "./pages/EncuestasResultadosPage";
import EncuestasPortalPage from "./pages/EncuestasPortalPage";
import EncuestasSchedulerPage from "./pages/EncuestasSchedulerPage";
import EncuestaPublicaPage from "./pages/EncuestaPublicaPage";
import VerificarChecklistPage from "./pages/VerificarChecklistPage";
import LeadFormPage from "./pages/LeadFormPage";import VerificarComparacionPage from "./pages/VerificarComparacionPage";
import EstadisticasPage from "./pages/EstadisticasPage";
import DashboardBIPage from "./pages/DashboardBIPage";
import PublicDashboardBIPage from "./pages/PublicDashboardBIPage";
import AccesosPortalesPage from "./pages/AccesosPortalesPage";
import CrmIntegracionPage from "./pages/CrmIntegracionPage";
import InformacionesGeneralesPage from "./pages/InformacionesGeneralesPage";
// Capacitaciones y Examenes
import CapacitacionesPage from "./pages/CapacitacionesPage";
import ExamenesPage from "./pages/ExamenesPage";
import SignageProgramadorPage from "./pages/SignageProgramadorPage";
import SignageDisplayPage from "./pages/SignageDisplayPage";
import ExamenPublicoPage from "./pages/ExamenPublicoPage";
import PublicContentPage from "./pages/PublicContentPage";
// Agenda de Trabajo
import AgendaTrabajoPage from "./pages/AgendaTrabajoPage";
import CotizacionesPage from "./pages/CotizacionesPage";
import ControlCotizacionesPage from "./pages/ControlCotizacionesPage";
import CotizacionDetailPage from "./pages/CotizacionDetailPage";
import ManualFloatingButton from "./components/ManualFloatingButton";
import { KpiCarouselDots } from "./components/KpiCarouselDots";
import { AtencionPrioritariaProvider } from "./contexts/AtencionPrioritariaContext";
import AtencionPrioritariaAlert from "./components/AtencionPrioritariaAlert";
import { FacturaMismoMesProvider } from "./contexts/FacturaMismoMesContext";
import FacturaMismoMesAlert from "./components/FacturaMismoMesAlert";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

// System Info Context - for dynamic branding
const SystemContext = createContext(null);

export const useSystem = () => useContext(SystemContext);

const SystemProvider = ({ children }) => {
  const [systemInfo, setSystemInfo] = useState({
    name: "QAsesores",
    slogan: "Corredores de Seguros y Reaseguros",
    logo_url: null
  });
  const [loadingSystem, setLoadingSystem] = useState(true);

  const fetchSystemInfo = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/config/system-info`);
      const data = response.data;
      setSystemInfo({
        name: data.name || "QAsesores",
        slogan: data.slogan || "",
        logo_url: data.logo_url || null,
        primary_color: data.primary_color,
        accent_color: data.accent_color
      });
      
      // Update document title with system name
      document.title = `${data.name || "QAsesores"} - Sistema de Gestión`;
    } catch (err) {
      console.error("Error loading system info:", err);
      document.title = "QAsesores - Sistema de Gestión";
    } finally {
      setLoadingSystem(false);
    }
  }, []);

  useEffect(() => {
    fetchSystemInfo();
  }, [fetchSystemInfo]);

  return (
    <SystemContext.Provider value={{ systemInfo, loadingSystem, refetchSystemInfo: fetchSystemInfo }}>
      {children}
    </SystemContext.Provider>
  );
};

// Theme Context
const ThemeContext = createContext(null);

export const useTheme = () => useContext(ThemeContext);

const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved === "true";
  });

  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Auth Context
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);
  const [forcePasswordChange, setForcePasswordChange] = useState(false);
  const [sidebarMenus, setSidebarMenus] = useState([]);
  const [sidebarMenusLoading, setSidebarMenusLoading] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          const res = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(res.data);
          setForcePasswordChange(res.data.force_password_change || false);
        } catch (e) {
          // Solo cerrar sesión si el token es realmente inválido (401/403).
          // Errores de red o caídas temporales del backend (deploys) no deben desloguear.
          const st = e.response?.status;
          if (st === 401 || st === 403) {
            localStorage.removeItem("token");
            setToken(null);
            setUser(null);
          }
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, [token]);

  // Fetch sidebar menus once when user is authenticated
  const fetchSidebarMenus = useCallback(async () => {
    if (!token) return;
    try {
      setSidebarMenusLoading(true);
      const res = await axios.get(`${API}/system/menus`, { headers: { Authorization: `Bearer ${token}` } });
      const menusData = res.data || [];
      menusData.sort((a, b) => (a.order || 0) - (b.order || 0));
      menusData.forEach(m => { if (m.submenus) m.submenus.sort((a, b) => (a.order || 0) - (b.order || 0)); });
      setSidebarMenus(menusData);
    } catch (err) {
      console.error("Error loading menus:", err);
    } finally {
      setSidebarMenusLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (user && token) {
      fetchSidebarMenus();
    }
    if (!user) {
      setSidebarMenus([]);
    }
  }, [user, token, fetchSidebarMenus]);

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("token", res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    setForcePasswordChange(res.data.force_password_change || false);
    return res.data;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const res = await axios.post(`${API}/auth/register`, { email, password, name });
    localStorage.setItem("token", res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setForcePasswordChange(false);
  }, []);

  const getAuthHeaders = useCallback(() => ({
    headers: { Authorization: `Bearer ${token}` }
  }), [token]);

  const updateUser = useCallback((updatedUser) => {
    setUser(updatedUser);
    if (updatedUser.force_password_change !== undefined) {
      setForcePasswordChange(updatedUser.force_password_change);
    }
  }, []);

  const clearForcePasswordChange = useCallback(() => {
    setForcePasswordChange(false);
    setUser(prev => prev ? { ...prev, force_password_change: false } : prev);
  }, []);

  const authContextValue = useMemo(() => ({ 
    user, 
    token, 
    loading, 
    login, 
    register, 
    logout, 
    getAuthHeaders,
    forcePasswordChange,
    updateUser,
    clearForcePasswordChange,
    sidebarMenus,
    sidebarMenusLoading,
    fetchSidebarMenus
  }), [user, token, loading, login, register, logout, getAuthHeaders, forcePasswordChange, updateUser, clearForcePasswordChange, sidebarMenus, sidebarMenusLoading, fetchSidebarMenus]);

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

const ProtectedRoute = ({ children, allowPasswordChange = false }) => {
  const { user, loading, forcePasswordChange } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  // Redirect to password change if forced (except when already on that page)
  if (forcePasswordChange && !allowPasswordChange) {
    return <Navigate to="/cambiar-contrasena" replace />;
  }
  
  // Mensajero users go directly to kiosk (unless already there)
  if (user.role?.toLowerCase() === "mensajero" && !location.pathname.startsWith("/app/entregas") && !location.pathname.startsWith("/cambiar-contrasena")) {
    return <Navigate to="/app/entregas" replace />;
  }
  
  return children;
};

// Redirect from /requisiciones/:id to /requisiciones/pendientes/:id (for old email links)
function RedirectToRequisicion() {
  const { requisicionId } = useParams();
  return <Navigate to={`/requisiciones/pendientes/${requisicionId}`} replace />;
}

// Redirect from /gestion-humana/solicitudes/:id to /gestion-humana/solicitudes-unificadas/:id
// (los correos transaccionales de GH apuntan a esta URL; la página real es la unificada)
function RedirectToSolicitudUnificada() {
  const { solicitudId } = useParams();
  return <Navigate to={`/gestion-humana/solicitudes-unificadas/${solicitudId}`} replace />;
}

// Redirect from /inventario/articulos/:id → lista de artículos
// (los correos de stock crítico apuntan al detalle; no existe página de detalle individual)
function RedirectToInventarioArticulos() {
  const { articuloId } = useParams();
  return <Navigate to={`/inventario/articulos?focus=${articuloId || ""}`} replace />;
}

function ReferrerTracker() {
  const location = useLocation();
  const prevRef = useRef(location.pathname);
  useEffect(() => {
    try {
      if (prevRef.current && prevRef.current !== location.pathname) {
        // Si el usuario está entrando a /reportar-error, guardamos la ruta
        // anterior para que la página pueda pre-seleccionar el módulo.
        if (location.pathname.startsWith("/reportar-error") && !prevRef.current.startsWith("/reportar-error")) {
          sessionStorage.setItem("report_referrer_path", prevRef.current);
        }
      }
      prevRef.current = location.pathname;
    } catch (_) { /* sessionStorage puede no estar disponible */ }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <SystemProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <AtencionPrioritariaProvider>
            <FacturaMismoMesProvider>
            <Toaster position="top-right" richColors />
            <ManualFloatingButton />
            <KpiCarouselDots />
            <BugResolvedAnnouncements />
            <TicketUrgenteAnnouncements />
            <AtencionPrioritariaAlert />
            <FacturaMismoMesAlert />
            <ReferrerTracker />
            <PushPermissionBanner />
            <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/encuesta/:token" element={<EncuestaPublicaPage />} />
            <Route path="/verificar-checklist/:folio" element={<VerificarChecklistPage />} />
            <Route path="/captar-lead" element={<LeadFormPage />} />
            <Route path="/verificar-comparacion/:folio" element={<VerificarComparacionPage />} />
            <Route path="/examen/:token" element={<ExamenPublicoPage />} />
            <Route path="/display/:token" element={<SignageDisplayPage />} />
            <Route path="/public/info/:token" element={<PublicContentPage />} />
            <Route path="/public/dashboard/:token" element={<PublicDashboardBIPage />} />
<Route path="/cambiar-contrasena" element={<ProtectedRoute allowPasswordChange={true}><CambiarContrasenaPage /></ProtectedRoute>} />
            <Route path="/reportar-error" element={<ProtectedRoute><ReportarErrorPage /></ProtectedRoute>} />
            <Route path="/admin/reportes-errores" element={<ProtectedRoute><AdminReportesErroresPage /></ProtectedRoute>} />
            <Route path="/admin/reportes-errores/:id" element={<ProtectedRoute><AdminReportesErroresPage /></ProtectedRoute>} />
            {/* Portal Cotizaciones ALNAP (PCC) — controlado por permisos pcc_* */}
            <Route path="/pcc" element={<ProtectedRoute><PCCPage /></ProtectedRoute>} />
            <Route path="/pcc/:section" element={<ProtectedRoute><PCCPage /></ProtectedRoute>} />
            {/* Pipelines (control de procesos) + submódulo Paneles */}
            <Route path="/pipelines" element={<ProtectedRoute><PipelinesPage /></ProtectedRoute>} />
            <Route path="/pipelines/paneles" element={<ProtectedRoute><PanelesPage /></ProtectedRoute>} />
            <Route path="/pipelines/informes" element={<ProtectedRoute><InformesPage /></ProtectedRoute>} />
            <Route path="/pipelines/informes-documentos" element={<ProtectedRoute><InformesDocumentosPage /></ProtectedRoute>} />
            <Route path="/pipelines/plantillas" element={<ProtectedRoute><PlantillasPipelinePage /></ProtectedRoute>} />
            <Route path="/pipelines/workflow" element={<ProtectedRoute><WorkflowPage /></ProtectedRoute>} />
            <Route path="/pipelines/tareas" element={<ProtectedRoute><TareasPipelinePage /></ProtectedRoute>} />
            {/* Portal público del empleado (sin auth, vía token único) */}
            <Route path="/pcc-portal/:token" element={<PCCPortalPage />} />
            {/* === ALNAP START === Demo provisional Portal Cotizaciones */}
            {process.env.REACT_APP_ENABLE_ALNAP === "true" && (
              <>
                <Route path="/alnap-demo" element={<ProtectedRoute><AlnapDemoPage /></ProtectedRoute>} />
                <Route path="/alnap-public/:token" element={<AlnapPublicPage />} />
              </>
            )}
            {/* === ALNAP END === */}
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/dashboard/ejecutivo" element={<ProtectedRoute><KPIDashboardPage /></ProtectedRoute>} />
            <Route path="/dashboard/mi-dashboard" element={<ProtectedRoute><MyDashboardPage /></ProtectedRoute>} />
            <Route path="/qaia" element={<ProtectedRoute><QAiaPage /></ProtectedRoute>} />
            <Route path="/compare" element={<ProtectedRoute><ComparePage /></ProtectedRoute>} />
            <Route path="/beneficios/comparar-renovaciones" element={<ProtectedRoute><ComparePage variant="personas" /></ProtectedRoute>} />
            <Route path="/converter" element={<ProtectedRoute><ConverterPage /></ProtectedRoute>} />
            <Route path="/publicidades" element={<ProtectedRoute><PublicidadesPage /></ProtectedRoute>} />
            <Route path="/coberturas" element={<ProtectedRoute><CoberturasPolizasPage /></ProtectedRoute>} />
            <Route path="/comparison/:id" element={<ProtectedRoute><ComparisonResultPage /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
            <Route path="/templates" element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
            {/* Reportes del Sistema */}
            <Route path="/reportes" element={<ProtectedRoute><ReportesSistemaPage /></ProtectedRoute>} />
            <Route path="/reportes/constructor" element={<ProtectedRoute><ReportesPersonalizadosPage /></ProtectedRoute>} />
            <Route path="/usuarios" element={<ProtectedRoute><UsuariosPage /></ProtectedRoute>} />
            <Route path="/gestion-humana" element={<ProtectedRoute><GestionHumanaPage /></ProtectedRoute>} />
            <Route path="/configuracion/permisos" element={<ProtectedRoute><PermisosPage /></ProtectedRoute>} />
            <Route path="/configuracion/automatizaciones" element={<ProtectedRoute><AutomatizacionesPage /></ProtectedRoute>} />
            <Route path="/configuracion/base-datos-flujos" element={<ProtectedRoute><BaseDatosFlujos /></ProtectedRoute>} />
            <Route path="/configuracion/auditoria" element={<ProtectedRoute><AuditLogPage /></ProtectedRoute>} />
            <Route path="/configuracion/departamentos" element={<ProtectedRoute><DepartamentosPage /></ProtectedRoute>} />
            <Route path="/configuracion/campos-personalizados" element={<ProtectedRoute><CamposPersonalizadosPage /></ProtectedRoute>} />
            <Route path="/configuracion/menus" element={<ProtectedRoute><AdminMenusPage /></ProtectedRoute>} />
            <Route path="/configuracion/notificaciones" element={<ProtectedRoute><NotificacionesConfigPage /></ProtectedRoute>} />
            <Route path="/configuracion/notificaciones/m365-callback" element={<ProtectedRoute><NotificacionesConfigPage /></ProtectedRoute>} />
            <Route path="/configuracion/notificaciones-push" element={<ProtectedRoute><NotificacionesPushPage /></ProtectedRoute>} />
            <Route path="/configuracion/personalizacion" element={<ProtectedRoute><PersonalizacionPage /></ProtectedRoute>} />
            <Route path="/configuracion/aprendizaje" element={<ProtectedRoute><AprendizajePage /></ProtectedRoute>} />
            <Route path="/configuracion/limpieza-bd" element={<ProtectedRoute><LimpiezaBaseDatosPage /></ProtectedRoute>} />
            <Route path="/configuracion/reglas-alertas" element={<ProtectedRoute><ReglasAlertasPage /></ProtectedRoute>} />
            <Route path="/configuracion/campos-obligatorios" element={<ProtectedRoute><CamposObligatoriosPage /></ProtectedRoute>} />
            <Route path="/configuracion/alertas-executor" element={<ProtectedRoute><AlertasExecutorPage /></ProtectedRoute>} />
            <Route path="/configuracion/backup" element={<ProtectedRoute><BackupPage /></ProtectedRoute>} />
            <Route path="/configuracion/plantillas-correos" element={<ProtectedRoute><PlantillasCorreosPage /></ProtectedRoute>} />
            <Route path="/configuracion/firma-digital" element={<ProtectedRoute><FirmaDigitalPage /></ProtectedRoute>} />
            <Route path="/configuracion/reglas-email" element={<ProtectedRoute><ReglasEmailPage /></ProtectedRoute>} />
            <Route path="/configuracion/email-logs" element={<ProtectedRoute><EmailLogsPage /></ProtectedRoute>} />
            <Route path="/configuracion/operaciones-usuario" element={<ProtectedRoute><OperacionesPorUsuarioPage /></ProtectedRoute>} />
            <Route path="/configuracion/clientes-mensajeria" element={<ProtectedRoute><ClientesMensajeriaPage /></ProtectedRoute>} />
            <Route path="/configuracion/datos-llamadas" element={<ProtectedRoute><ConfigLlamadasPage /></ProtectedRoute>} />
            <Route path="/configuracion/accesos-portales" element={<ProtectedRoute><AccesosPortalesPage /></ProtectedRoute>} />
            {/* CRM Externo */}
            <Route path="/crm-externo/datos" element={<ProtectedRoute><CrmIntegracionPage tab="datos" /></ProtectedRoute>} />
            <Route path="/presentaciones-ia" element={<ProtectedRoute><PresentacionesIAPage /></ProtectedRoute>} />
            <Route path="/crm-externo/configuracion" element={<ProtectedRoute><CrmIntegracionPage tab="configuracion" /></ProtectedRoute>} />
            <Route path="/informaciones-generales" element={<ProtectedRoute><InformacionesGeneralesPage /></ProtectedRoute>} />
            {/* Capacitaciones y Examenes */}
            <Route path="/capacitaciones/cursos" element={<ProtectedRoute><CapacitacionesPage /></ProtectedRoute>} />
            <Route path="/capacitaciones/mi-progreso" element={<ProtectedRoute><CapacitacionesPage /></ProtectedRoute>} />
            <Route path="/capacitaciones/dashboard" element={<ProtectedRoute><CapacitacionesPage /></ProtectedRoute>} />
            <Route path="/capacitaciones/certificados" element={<ProtectedRoute><CapacitacionesPage /></ProtectedRoute>} />
            <Route path="/examenes" element={<ProtectedRoute><ExamenesPage /></ProtectedRoute>} />
            <Route path="/examenes/banco-preguntas" element={<ProtectedRoute><ExamenesPage /></ProtectedRoute>} />
            <Route path="/examenes/resultados" element={<ProtectedRoute><ExamenesPage /></ProtectedRoute>} />
            <Route path="/cartelera-digital" element={<ProtectedRoute><SignageProgramadorPage /></ProtectedRoute>} />
            {/* Agenda de Trabajo */}
            <Route path="/finanzas/agenda-trabajo" element={<ProtectedRoute><AgendaTrabajoPage /></ProtectedRoute>} />
            <Route path="/cotizaciones" element={<ProtectedRoute><CotizacionesPage /></ProtectedRoute>} />
            <Route path="/cotizaciones/control-cotizaciones" element={<ProtectedRoute><ControlCotizacionesPage /></ProtectedRoute>} />
            <Route path="/cotizaciones/:id" element={<ProtectedRoute><CotizacionDetailPage /></ProtectedRoute>} />
            {/* Control de Llamadas */}
            <Route path="/riesgos-generales/control-llamadas" element={<ProtectedRoute><ControlLlamadasPage /></ProtectedRoute>} />
            {/* Control de Renovaciones */}
            <Route path="/riesgos-generales/control-renovaciones" element={<ProtectedRoute><ControlRenovacionesPage /></ProtectedRoute>} />
            <Route path="/riesgos-personas/control-renovaciones" element={<ProtectedRoute><ControlRenovacionesPage /></ProtectedRoute>} />
            <Route path="/riesgos-personas/control-renovaciones" element={<ProtectedRoute><ControlRenovacionesPage /></ProtectedRoute>} />
            <Route path="/riesgos-generales/bandeja-entrada" element={<ProtectedRoute><BandejaEntradaPage /></ProtectedRoute>} />
            <Route path="/sistema-ponche" element={<ProtectedRoute><SistemaPonchePage /></ProtectedRoute>} />
            <Route path="/camaras" element={<ProtectedRoute><CamarasPage /></ProtectedRoute>} />
            <Route path="/cobros/tarjetas" element={<ProtectedRoute><TarjetasCreditoPage /></ProtectedRoute>} />
            <Route path="/cobros/cheques" element={<ProtectedRoute><ChequesQBPage /></ProtectedRoute>} />
            <Route path="/finanzas/dgii" element={<ProtectedRoute><DGIIReportesPage /></ProtectedRoute>} />
            <Route path="/registro-tarjeta/:token" element={<RegistroTarjetaPublicaPage />} />
            <Route path="/ver-tarjeta-aseguradora/:token" element={<VerTarjetaAseguradoraPage />} />
            <Route path="/salida-equipos" element={<ProtectedRoute><SalidaEquiposPage /></ProtectedRoute>} />
            <Route path="/riesgos-generales/plantillas-aseguradoras" element={<ProtectedRoute><PlantillasAseguradorasPage /></ProtectedRoute>} />
            {/* Encuestas NPS Module */}
            <Route path="/encuestas/portal" element={<ProtectedRoute><EncuestasPortalPage /></ProtectedRoute>} />
            <Route path="/encuestas/configuracion" element={<ProtectedRoute><EncuestasConfigPage /></ProtectedRoute>} />
            <Route path="/encuestas/campanas" element={<ProtectedRoute><EncuestasCampanasPage /></ProtectedRoute>} />
            <Route path="/encuestas/resultados" element={<ProtectedRoute><EncuestasResultadosPage /></ProtectedRoute>} />
            <Route path="/encuestas/scheduler" element={<ProtectedRoute><EncuestasSchedulerPage /></ProtectedRoute>} />
            {/* Estadísticas Module */}
            <Route path="/estadisticas" element={<ProtectedRoute><EstadisticasPage /></ProtectedRoute>} />
            <Route path="/estadisticas-empresariales" element={<ProtectedRoute><DashboardBIPage /></ProtectedRoute>} />
            <Route path="/estadisticas-empresariales/:dashboardId" element={<ProtectedRoute><DashboardBIPage /></ProtectedRoute>} />
            {/* WhatsApp Module */}
            <Route path="/whatsapp/bandeja" element={<ProtectedRoute><WhatsAppBandejaPage /></ProtectedRoute>} />
            <Route path="/whatsapp/conversaciones" element={<ProtectedRoute><WhatsAppBandejaPage /></ProtectedRoute>} />
            <Route path="/whatsapp/asignaciones" element={<ProtectedRoute><WhatsAppAsignacionesPage /></ProtectedRoute>} />
            <Route path="/whatsapp/respuestas" element={<ProtectedRoute><WhatsAppRespuestasPage /></ProtectedRoute>} />
            <Route path="/whatsapp/plantillas" element={<ProtectedRoute><WhatsAppPlantillasPage /></ProtectedRoute>} />
            <Route path="/whatsapp/configuracion" element={<ProtectedRoute><WhatsAppConfigPage /></ProtectedRoute>} />
            <Route path="/whatsapp/chatbot" element={<ProtectedRoute><WhatsAppChatbotPage /></ProtectedRoute>} />
            <Route path="/whatsapp/contactos" element={<ProtectedRoute><WhatsAppContactosPage /></ProtectedRoute>} />
            <Route path="/whatsapp/estadisticas" element={<ProtectedRoute><WhatsAppEstadisticasPage /></ProtectedRoute>} />
            <Route path="/whatsapp/workflow" element={<ProtectedRoute><WhatsAppWorkflowPage /></ProtectedRoute>} />
            {/* Marketing - Articulos Module */}
            <Route path="/articulos" element={<ProtectedRoute><ArticulosPage /></ProtectedRoute>} />
            {/* Inventario Module */}
            <Route path="/inventario" element={<ProtectedRoute><InventarioDashboardPage /></ProtectedRoute>} />
            <Route path="/inventario/entradas" element={<ProtectedRoute><EntradasInventarioPage /></ProtectedRoute>} />
            <Route path="/inventario/salidas" element={<ProtectedRoute><SalidasInventarioPage /></ProtectedRoute>} />
            <Route path="/inventario/movimientos" element={<ProtectedRoute><MovimientosInventarioPage /></ProtectedRoute>} />
            <Route path="/inventario/categorias" element={<ProtectedRoute><CategoriasInventarioPage /></ProtectedRoute>} />
            <Route path="/inventario/auditoria" element={<ProtectedRoute><AuditoriaInventarioPage /></ProtectedRoute>} />
            <Route path="/inventario/articulos" element={<ProtectedRoute><InventarioArticulosPage /></ProtectedRoute>} />
            <Route path="/inventario/articulos/:articuloId" element={<ProtectedRoute><RedirectToInventarioArticulos /></ProtectedRoute>} />
            {/* Mobiliario Module */}
            <Route path="/mobiliario" element={<ProtectedRoute><MobiliarioDashboardPage /></ProtectedRoute>} />
            <Route path="/mobiliario/activos" element={<ProtectedRoute><MobiliarioActivosPage /></ProtectedRoute>} />
            <Route path="/mobiliario/asignaciones" element={<ProtectedRoute><MobiliarioAsignacionesPage /></ProtectedRoute>} />
            <Route path="/mobiliario/mantenimiento" element={<ProtectedRoute><MobiliarioMantenimientoPage /></ProtectedRoute>} />
            <Route path="/mobiliario/bajas" element={<ProtectedRoute><MobiliarioBajasPage /></ProtectedRoute>} />
            <Route path="/mobiliario/categorias" element={<ProtectedRoute><MobiliarioCategoriasPage /></ProtectedRoute>} />
            <Route path="/mobiliario/ubicaciones" element={<ProtectedRoute><MobiliarioUbicacionesPage /></ProtectedRoute>} />
            {/* Finanzas Module */}
            <Route path="/medicamentos" element={<ProtectedRoute><MedicamentosPage /></ProtectedRoute>} />
            <Route path="/caja-chica" element={<ProtectedRoute><CajaChicaPage /></ProtectedRoute>} />
            <Route path="/grabaciones" element={<ProtectedRoute><GrabacionesPage /></ProtectedRoute>} />
            <Route path="/lionbridge/cuadre-caja" element={<ProtectedRoute><LionBridgeCuadreCajaPage /></ProtectedRoute>} />
            <Route path="/lionbridge/emisiones" element={<ProtectedRoute><LionbridgeEmisionesPage /></ProtectedRoute>} />
            <Route path="/caja-chica/configuracion" element={<ProtectedRoute><CajaChicaConfigPage /></ProtectedRoute>} />
            {/* Cuentas por Pagar Module */}
            <Route path="/cuentas-pagar" element={<ProtectedRoute><CuentasPagarPage /></ProtectedRoute>} />
            <Route path="/cuentas-pagar/proveedores" element={<ProtectedRoute><ProveedoresPage /></ProtectedRoute>} />
            <Route path="/cuentas-pagar/alertas" element={<ProtectedRoute><AlertasPagosPage /></ProtectedRoute>} />
            <Route path="/cuentas-pagar/historial" element={<ProtectedRoute><HistorialCuentasPagarPage /></ProtectedRoute>} />
            {/* Requisiciones Module */}
            <Route path="/requisiciones" element={<ProtectedRoute><RequisicionesPage /></ProtectedRoute>} />
            <Route path="/requisiciones/nueva" element={<ProtectedRoute><NuevaRequisicionPage /></ProtectedRoute>} />
            <Route path="/requisiciones/pendientes" element={<ProtectedRoute><AprobarRequisicionPage /></ProtectedRoute>} />
            <Route path="/requisiciones/pendientes/:requisicionId" element={<ProtectedRoute><AprobarRequisicionPage /></ProtectedRoute>} />
            <Route path="/requisiciones/:requisicionId" element={<ProtectedRoute><RedirectToRequisicion /></ProtectedRoute>} />
            <Route path="/requisiciones/historial" element={<ProtectedRoute><HistorialRequisicionesPage /></ProtectedRoute>} />
            <Route path="/beneficios/aseguradoras" element={<ProtectedRoute><AseguradorasPage /></ProtectedRoute>} />
            <Route path="/beneficios/planes" element={<ProtectedRoute><PlanesPage /></ProtectedRoute>} />
            <Route path="/beneficios/comparativos" element={<ProtectedRoute><ComparativosBeneficiosPage /></ProtectedRoute>} />
            <Route path="/beneficios/plantillas" element={<ProtectedRoute><PlantillasBeneficiosPage /></ProtectedRoute>} />
            {/* Gestión Humana sub-routes */}
            <Route path="/gestion-humana/empleados" element={<ProtectedRoute><EmpleadosPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/vacaciones" element={<ProtectedRoute><VacacionesPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/vacaciones/:solicitudId" element={<ProtectedRoute><VacacionesPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/reclutamiento" element={<ProtectedRoute><ReclutamientoPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/plantillas" element={<ProtectedRoute><PlantillasGHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/solicitudes" element={<ProtectedRoute><SolicitudesGHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/solicitudes/:solicitudId" element={<ProtectedRoute><RedirectToSolicitudUnificada /></ProtectedRoute>} />
            <Route path="/gestion-humana/solicitudes-unificadas" element={<ProtectedRoute><SolicitudesUnificadasPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/solicitudes-unificadas/:solicitudId" element={<ProtectedRoute><SolicitudesUnificadasPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/movimientos" element={<ProtectedRoute><MovimientosGHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/parametros" element={<ProtectedRoute><ParametrosGHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/dashboard" element={<ProtectedRoute><DashboardRRHHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/nomina" element={<ProtectedRoute><NominaPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/permisos" element={<ProtectedRoute><PermisosGHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/permisos/:id" element={<ProtectedRoute><PermisosGHPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/cumpleanos" element={<ProtectedRoute><CumpleanosPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/tardanzas" element={<ProtectedRoute><TardanzasPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/solicitud" element={<ProtectedRoute><SolicitudesUnificadasPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/alertas-solicitudes" element={<ProtectedRoute><AlertasSolicitudesPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/procesos-internos" element={<ProtectedRoute><ProcesosInternosPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/portal-procedimientos" element={<ProtectedRoute><PortalProcedimientosPage /></ProtectedRoute>} />
            {/* Mensajería routes */}
            <Route path="/mensajeria/solicitudes" element={<ProtectedRoute><SolicitudesMensajeriaPage /></ProtectedRoute>} />
            <Route path="/mensajeria/solicitudes/:solicitudId" element={<ProtectedRoute><SolicitudesMensajeriaPage /></ProtectedRoute>} />
            <Route path="/mensajeria/mensajeros" element={<ProtectedRoute><MensajerosPage /></ProtectedRoute>} />
            <Route path="/mensajeria/tipos-documento" element={<ProtectedRoute><TiposDocumentoPage /></ProtectedRoute>} />
            <Route path="/mensajeria/plantillas" element={<ProtectedRoute><PlantillasMensajeriaPage /></ProtectedRoute>} />
            <Route path="/mensajeria/historial" element={<ProtectedRoute><HistorialMensajeriaPage /></ProtectedRoute>} />
            <Route path="/mensajeria/chat" element={<ProtectedRoute><ChatMensajeriaPage /></ProtectedRoute>} />
            <Route path="/mensajeria/alertas" element={<ProtectedRoute><AlertasMensajeriaPage /></ProtectedRoute>} />
            <Route path="/mensajeria/correspondencia-interna" element={<ProtectedRoute><CorrespondenciaInternaPage /></ProtectedRoute>} />
            {/* Mesa de Ayuda routes */}
            <Route path="/mesa-ayuda/tickets" element={<ProtectedRoute><TicketsPage /></ProtectedRoute>} />
            <Route path="/mesa-ayuda/tickets/:ticketId" element={<ProtectedRoute><TicketsPage /></ProtectedRoute>} />
            <Route path="/mesa-ayuda/mis-tickets" element={<ProtectedRoute><MisTicketsPage /></ProtectedRoute>} />
            <Route path="/mesa-ayuda/categorias" element={<ProtectedRoute><CategoriasTicketPage /></ProtectedRoute>} />
            <Route path="/mesa-ayuda/prioridades" element={<ProtectedRoute><PrioridadesTicketPage /></ProtectedRoute>} />
            <Route path="/mesa-ayuda/plantillas" element={<ProtectedRoute><PlantillasTicketsPage /></ProtectedRoute>} />
            <Route path="/gestion-humana/hallazgos-auditoria" element={<ProtectedRoute><HallazgosAuditoriaPage /></ProtectedRoute>} />
            <Route path="/auditorias/hallazgos-auditoria" element={<ProtectedRoute><HallazgosAuditoriaPage /></ProtectedRoute>} />
            <Route path="/auditorias/hallazgos-auditoria/:ticketId" element={<ProtectedRoute><HallazgosAuditoriaPage /></ProtectedRoute>} />
            <Route path="/manual" element={<ProtectedRoute><ManualPage /></ProtectedRoute>} />
            {/* Mobile App routes - uses MobileLayout without sidebar */}
            <Route path="/app/entregas" element={
              <ProtectedRoute>
                <MobileLayout>
                  <AppEntregasPage />
                </MobileLayout>
              </ProtectedRoute>
            } />
            <Route path="/mensajeria/app-movil" element={<ProtectedRoute><AppMovilConfigPage /></ProtectedRoute>} />
            {/* Control Visitantes Module */}
            <Route path="/visitantes" element={<ProtectedRoute><ControlVisitantesPage /></ProtectedRoute>} />
            <Route path="/visitantes/historial" element={<ProtectedRoute><HistorialVisitasPage /></ProtectedRoute>} />
            <Route path="/visitantes/tipos" element={<ProtectedRoute><TiposVisitaPage /></ProtectedRoute>} />
            <Route path="/visitantes/reportes" element={<ProtectedRoute><ReportesVisitasPage /></ProtectedRoute>} />
            <Route path="/visitantes/alertas" element={<ProtectedRoute><AlertasVisitantesPage /></ProtectedRoute>} />
          </Routes>
            </FacturaMismoMesProvider>
            </AtencionPrioritariaProvider>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
    </SystemProvider>
  );
}

export default App;
